.cl{border:1px solid #ddd;}